import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';

/**
 * Updates metafield rich text when the product variant changes (same pattern as price-per-serving).
 *
 * @extends {Component<{ output: HTMLElement }>}
 */
class VariantMetafield extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const { output } = this.refs;
    const next = event.detail.data.html.querySelector(
      `variant-metafield[data-block-id="${this.dataset.blockId}"]`
    );
    if (!next || !output) return;

    const nextOutput = next.querySelector('[ref="output"]');
    if (!nextOutput) return;

    this.classList.toggle('hidden', next.classList.contains('hidden'));
    output.innerHTML = nextOutput.innerHTML;
  };
}

if (!customElements.get('variant-metafield')) {
  customElements.define('variant-metafield', VariantMetafield);
}
